<template>
  <v-select
    :value="value"
    @input="value => emit(value)"
    :label="config.label"
    :items="experts"
    item-text="nickname"
    item-value="id"
    :required="config.required"
    :error="haveErrors()"
    :rules="config.errors"
    multiple chips dark>
  </v-select>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import input from '@/mixins/input'
  export default {
    mixins: [input],
    computed: mapGetters({
      experts: 'skiliko/experts/experts'
    }),
    methods: mapActions({
      fetchExperts: 'skiliko/experts/fetchAll'
    }),
    beforeMount () {
      this.fetchExperts()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/Experts.vue